import Button from '@mui/material/Button'
import { Theme } from '@mui/material/styles'
import { withStyles } from 'tss-react/mui'

const ButtonWIthCustomCSS = withStyles(Button, (theme: Theme) => ({
  root: {
    color: '#FF4500 !important',
    border: '4px solid #FF4500',
    lineHeight: '120%',
    backgroundColor: '#fff !important',
    borderRadius: '27px',
    boxSizing: 'border-box',
    padding: '6px 25px',
    textAlign: 'center',
    fontSize: '18px',
    letterSpacing: '0.12em',
    minHeight: '48px',
    height: 'auto',
    '&:hover': {
      backgroundColor: '#FF4500 !important',
      color: '#fff !important',
    },
    '&.Mui-disabled': {
      opacity: 0.5,
    },
    [theme.breakpoints.between(0, 600)]: {
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0.07em',
      minHeight: '48px',
    },
  },
}))

export default ButtonWIthCustomCSS
